/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit, ViewChild } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';

import { GlobalMessageService } from '../../services/global-message.service';
import { AdminService } from './../../services/admin.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { SessionService } from './../../services/session2.service';
import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';
import { DateRangePickerComponent } from '../../global/date-range/date-range-picker.component';

@Component({
  selector: 'app-admin-jobs',
  templateUrl: './admin-jobs.component.html',
  styleUrls: ['./admin-jobs.component.scss']
})
export class AdminJobsComponent implements OnInit {

  tab: string = 'rerun';
  jobs: any[] = [];

  maxAllowed: number = 5000;

  // account and account selector
  selectedAccount: any[];
  accounts: any[] = [];
  accountDDSettings: any = {
    text: 'Account',
    enableSearchFilter: true,
    badgeShowLimit: 1,
    singleSelection: true,
    classes: 'font-size-sm'
  };

  // state management
  loading: any = {
    accounts: false,
    jobs: false,
    emailCount: false
  };

  @ViewChild(DateRangePickerComponent) dateRange: DateRangePickerComponent;

  dateRangeOptions: any = {
    minDate: '01/01/2015',
    format: 'MM/DD/YYYY',
    autoApply: true
  };

  selAll: boolean = false;
  startDate: Date;
  endDate: Date;
  taskType: string = 'all';
  runReady: boolean = false;
  tooMany: boolean = false;
  taskCount: number = 0;
  emailCount: number = 0;

  constructor(
    private globalMessageService: GlobalMessageService,
    private adminService: AdminService,
    private cacheService: CacheService,
    private sessionService: SessionService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    if (!this.cacheService.get('session')) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.initView();
        }
      );
    }
    else {
      this.initView();
    }
  }

  changeAccount() {
    this.refreshJobs();
  }

  setRange(range: any) {
    this.startDate = range.start;
    this.endDate = range.end;
    this.formatStartEnd();
    this.getCounts();
  }

  changeTaskType() {
    if (this.taskType == 'all') {
      this.selAll = false;
      this.selectAll();
    }
    else {
      // de-select all first
      this.selAll = true;
      this.selectAll();

      // now select valid tasks
      this.jobs.forEach((job) => {
        if (job.enabled) {
          job.tasks.forEach((t: any) => {
            if (t.enabled && t.valid && t.type == this.taskType) {
              t.pretty.selected = true;
              job.pretty.selected = true;
            }
          });
        }
      });
    }

    this.getCounts();
  }

  selectAll() {
    this.selAll = !this.selAll;
    this.jobs.forEach((job) => {
      if (job.enabled) {
        job.pretty.selected = this.selAll;
        job.tasks.forEach((t) => {
          if (t.enabled && t.valid) {
            t.pretty.selected = this.selAll;
          }
        });
      }
    });
    this.getCounts();
  }

  selectJob(job: any) {
    if (job.enabled) {
      job.pretty.selected = !job.pretty.selected;
      job.tasks.forEach((t) => {
        if (t.enabled && t.valid) {
          t.pretty.selected = job.pretty.selected;
        }
      });
    }
    this.getCounts();
  }

  selectTask(job: any, task: any) {
    if (task.enabled && task.valid) {
      task.pretty.selected = !task.pretty.selected;
    }

    // uncheck job if no tasks are selected
    let oneSelected: boolean = false;
    job.tasks.forEach((t) => {
      if (t.pretty.selected) {
        oneSelected = true;
      }
    });
    job.pretty.selected = oneSelected;
    this.getCounts();
  }

  refresh() {
    this.getCounts();
  }

  reRun() {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to re-run ${this.emailCount} email(s) through selected tasks`,
        confirm: () => {
          let emailTypes: string[] = [];
          let tasks: any = {};
          me.jobs.forEach((job) => {
            if (job.pretty.selected) {
              // get the distinct types for all selected jobs
              let typeFilter = job.filters.find((f) => f.type == 'email_type');
              typeFilter.include.forEach((t) => {
                if (emailTypes.indexOf(t) < 0) {
                  emailTypes.push(t);
                }
              });

              job.tasks.forEach((t) => {
                if (t.pretty.selected == true) {
                  if (tasks[t.type]) {
                    if (job.type.startsWith('bot')) {
                      tasks.bot.push({ email_types: typeFilter.include });
                    }
                    else {
                      tasks[t.type].push({ taskId: t.taskId, email_types: typeFilter.include });
                    }
                  }
                  else {
                    if (job.type.startsWith('bot')) {
                      tasks.bot = [{ email_types: typeFilter.include }];
                    }
                    else {
                      tasks[t.type] = [{ taskId: t.taskId, email_types: typeFilter.include }];
                    }
                  }
                }
              });
            }
          });

          let model = {
            email_types: emailTypes,
            tasks: tasks,
            start_date: me.startDate,
            end_date: me.endDate
          };

          me.adminService.executeRerun(me.selectedAccount[0].id, model).subscribe(
            (result: any) => {
              me.globalMessageService.message(`${result.count} items were added to the job queue`);
            },
            (error) => {
              // TODO
            }
          );
        }
      }
    }));
  }

  updateTasks(pStatus: boolean, pReason: string = null) {
    let me = this;
    let updatedSkills = [];
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: 'Please confirm you would like to pause the selected tasks. Note that paused skills will generate paused batches',
        confirm: () => {
          me.jobs.forEach((job) => {
            let jt: any = {};
            let tl = [];
            job.tasks.forEach((t) => {
              if (t.pretty.selected == true && t.paused != pStatus) {
                t.paused = pStatus;
                t.paused_reason = pReason;
                tl.push(t);
              }
            });
            if (tl.length > 0) {
              jt.jid = job._id;
              jt.updatedTasks = tl;
              updatedSkills.push(jt);
            }
          });

          // safety check in case we didn't load the tasks
          if (updatedSkills.length > 0) {
            me.adminService.updateTasks(updatedSkills).subscribe(
              (result: any) => {
                me.globalMessageService.message(`tasks ` + (pStatus == true ? 'paused' : 'resumed'));
                if (this.tab == 'showpaused') {
                  this.tabPausedClicked();
                }
              },
              (error) => {
                // TODO: show or log error?
              }
            );
          }
        }
      }
    }));
  }

  private getCounts() {
    let emailTypes: string[] = [];
    this.taskCount = 0;
    this.emailCount = 0;
    this.runReady = false;
    this.jobs.forEach((job) => {
      if (job.pretty.selected) {
        // get the distinct types for all selected jobs
        let typeFilter = job.filters.find((f) => f.type == 'email_type');
        typeFilter.include.forEach((t) => {
          if (emailTypes.indexOf(t) < 0) {
            emailTypes.push(t);
          }
        });

        job.tasks.forEach((t) => {
          if (t.pretty.selected == true) {
            this.taskCount++;
          }
        });
      }
    });
    if (this.taskCount > 0 && emailTypes.length > 0) {
      this.loading.emailCount = true;
      this.adminService.getRerunEmailCount(this.selectedAccount[0].id, emailTypes, this.startDate, this.endDate).subscribe(
        (result: any) => {
          this.emailCount = result.count;
          if (this.emailCount > 0) {
            this.runReady = true;
          }
          if (this.emailCount > this.maxAllowed) {
            this.tooMany = true;
          } else {
            this.tooMany = false;
          }
          this.loading.emailCount = false;
        }
      );
    }
  }

  private refreshJobs() {
    this.loading.jobs = true;
    this.adminService.getJobsForAccount(this.selectedAccount[0].id).subscribe(
      (result: any) => {
        this.jobs = result;
        this.jobs.forEach((job) => {
          job.pretty = {
            selected: false,
            tasks: job.tasks.map((jt) => jt.type)
          };
          job.valid = !job.deleted && job.enabled;
          let typeFilter = job.filters.find((f) => f.type == 'email_type');
          job.pretty.types = typeFilter.include.join(' | ');
          job.tasks.forEach((jt) => {
            jt.pretty = {
              selected: false
            };
            if (jt.type == 'route') {
              jt.pretty.summary = jt.settings.type;
              if (jt.settings.type == 'dynamic' && jt.settings.dynamic && jt.settings.dynamic.length > 0) {
                jt.pretty.summary += ` | ${jt.settings.dynamic}`;
              }
              if (jt.settings.type == 'leadowner' && jt.settings.lead_owner) {
                if (jt.settings.lead_owner.partner) {
                  jt.pretty.summary += ` | ${jt.settings.lead_owner.partner}`;
                }
              }
              if (jt.settings.static && jt.settings.static.length > 0) {
                jt.pretty.summary += ` | ${jt.settings.static.map((s) => s.email_address).join(', ')}`;
              }
            }
            else if (jt.type == 'track' || jt.type == 'create') {
              jt.pretty.summary = jt.settings.partner;
              if (jt.settings.list && jt.settings.list.name) {
                jt.pretty.summary += ` | List: ${jt.settings.list.name}`;
              }
              jt.pretty.summary += ` | Fields: ${jt.settings.static_fields.length + jt.settings.siftrock_fields.length}`;
            }
          });
        });
        this.loading.jobs = false;
      },
      (error) => {
        // noop
      }
    );
  }

  private initView() {
    this.loading.accounts = true;
    this.startDate = new Date();
    this.endDate = new Date();
    this.formatStartEnd();
    this.adminService.getAccounts().subscribe((result: any) => {
      result.forEach((a) => {
        this.accounts.push({ id: a._id, itemName: a.name });
      });

      this.accounts.sort((a, b) => {
        if (a.itemName.toLowerCase() > b.itemName.toLowerCase()) {
          return 1;
        }
        else {
          return -1;
        }
      });

      this.loading.accounts = false;
      // TEMP for dev
      // this.selectedAccount = [this.accounts.find(a=> { return a.itemName == 'Siftrock Demo'})];
      // this.changeAccount();
    });
  }

  private formatStartEnd() {
    this.startDate.setHours(0, 0, 0, 0);
    this.endDate.setHours(23, 59, 59, 999);
  }

  private resetData() {
    this.tab = name;
    this.jobs = [];
    this.selectedAccount = [];
  }

  private tabPausedClicked() {
    this.resetData();
    this.tab = 'showpaused';

    this.loading.jobs = true;
    this.adminService.getAllPausedJobs().subscribe(
      (result: any) => {
        this.jobs = result;
        this.jobs.forEach((job) => {
          job.pretty = {
            selected: false,
            tasks: job.tasks.map((jt) => jt.type)
          };
          job.pretty.accountName = this.accounts.find((a) => a.id == job.account_id).itemName;
          job.valid = !job.deleted && job.enabled;
          let typeFilter = job.filters.find((f) => f.type == 'email_type');
          job.pretty.types = typeFilter.include.join(' | ');
          job.tasks.forEach((jt) => {
            jt.pretty = {
              selected: false
            };
            if (jt.type == 'route') {
              jt.pretty.summary = jt.settings.type;
              if (jt.settings.type == 'dynamic' && jt.settings.dynamic && jt.settings.dynamic.length > 0) {
                jt.pretty.summary += ` | ${jt.settings.dynamic}`;
              }
              if (jt.settings.type == 'leadowner' && jt.settings.lead_owner) {
                if (jt.settings.lead_owner.partner) {
                  jt.pretty.summary += ` | ${jt.settings.lead_owner.partner}`;
                }
              }
              if (jt.settings.static && jt.settings.static.length > 0) {
                jt.pretty.summary += ` | ${jt.settings.static.map((s) => s.email_address).join(', ')}`;
              }
            }
            else if (jt.type == 'track' || jt.type == 'create') {
              jt.pretty.summary = jt.settings.partner;
              if (jt.settings.list && jt.settings.list.name) {
                jt.pretty.summary += ` | List: ${jt.settings.list.name}`;
              }
              jt.pretty.summary += ` | Fields: ${jt.settings.static_fields.length + jt.settings.siftrock_fields.length}`;
            }
          });
        });
        this.loading.jobs = false;
      },
      (error) => {
        // noop
      }
    );

  }

  private tabRerunClicked() {
    this.resetData();
    this.tab = 'rerun';
  }

}



// WEBPACK FOOTER //
// ./client/app/admin/admin-jobs/admin-jobs.component.ts